export const madoAccountFrag = `
    id
    code
    name
    category
    reconciliation
    type
`;
